<template>
  <div class='compliance-severity-container'>
    <div class="compliance-severity-text" :style="style">
      {{ getSeverity }}
    </div>
  </div>
</template>

<script>

import { hexToRgba } from '@/utils/colorUtils';

export default {
  name: 'SeverityTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getSeverity() {
      return this.item.severity;
    },
    colorsForLevels() {
      const severity = this.getSeverity;
      if (severity === this.$t('critical')) {
        return { color: '#DF399F' };
      }
      if (severity === this.$t('high')) {
        return { color: '#FF7F00' };
      }
      if (severity === this.$t('medium')) {
        return { color: '#2459D5' };
      }
      return { color: '#2BAF69' };
    },
    style() {
      return {
        backgroundColor: hexToRgba(this.colorsForLevels.color, 0.1),
        ...this.colorsForLevels,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.compliance-severity-container {
  .compliance-severity-text{
    text-transform: capitalize;
    color: var(--text-primary);
    font-size: rem(14);
    font-family: $font-family-semibold;
    line-height: 1.2em;
    display: flex;
    align-items: center;
    width: rem(70);
    height: rem(25);
    justify-content: center;
    margin-top: rem(12);
    border-radius: $radius-md;
  }
}
</style>
